import { BrowserRouter as Router } from "react-router-dom";
import { AppRoutes } from './routes.tsx';
import { ThemeProvider } from "./ThemeContext/ThemeContext";
import { MGTProviderSetup } from "./MGTProviderSetup";
import "../src/assets/css/custom.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";
import "./assets/css/custom.css";
import { BrokenLinkDialogProvider } from "./Context/BrokenLinkDialogContext"; 
import { NetworkProvider } from "./Context/NetworkProvider.tsx";
import PlanAccessDeniedDialog from "./Components/PlanAccessDeniedDialog";

export default function App() {
  return (
    <NetworkProvider>
    <ThemeProvider>
      <BrokenLinkDialogProvider>
        <MGTProviderSetup />
        <Router>
          <PlanAccessDeniedDialog />
          <AppRoutes />
        </Router>
        </BrokenLinkDialogProvider>
    </ThemeProvider>
    </NetworkProvider>
  );
}
